import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MagazinePageComponent } from './magazine-page/magazine-page.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { MagazineRoutingModule } from '@app/magazine/magazine-routing.module';
import { MagazineNewsComponent } from './magazine-news/magazine-news.component';
import { MagazineEventsComponent } from './magazine-events/magazine-events.component';
import { BsDropdownModule } from 'ngx-bootstrap';
import { SharedModule } from '@app/shared/shared.module';
import { NewsModule } from '@app/news/news.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EventsModule } from '@app/events/events.module';

@NgModule({
  imports: [
    BsDropdownModule,
    CommonModule,
    InlineSVGModule,
    MagazineRoutingModule,
    SharedModule,
    InfiniteScrollModule,
    NewsModule,
    EventsModule,
  ],
  declarations: [
    MagazinePageComponent,
    MagazineNewsComponent,
    MagazineEventsComponent,
  ]
})
export class MagazineModule { }



// WEBPACK FOOTER //
// ./src/app/magazine/magazine.module.ts